export const GOOGLE_LIBRARIES = ['places'];
export const GOOGLE_API_KEY = 'AIzaSyBjZcO-lMRLE7w9onAbHa3NrnkKuw3HSs0';
